import Vue from "vue";
import Vuex from "vuex";
import auth from "./store/auth";
import settings from "./store/settings";
import agGrid from "./store/agGrid";
import clients from "./store/clients";
import systems from "./store/systems";
import emailTemplates from "./store/emailTemplates";
import users from "./store/users";
import bases from "./store/bases";
import items from "./store/items";
import loot from "./store/loot";
import config from "./store/config";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    settings,
    agGrid,
    clients,
    systems,
    emailTemplates,
    users,
    bases,
    items,
    loot,
    config
  }
});
